import { Typography } from '@fe-toolkit/web-components/ssr'

import { ChangePlanUIInfo } from '../../utils/formatPlanPaymentAttributes'
import AlertWithScrollIntoView from '../../components/AlertWithScrollIntoView'

type ChangePlanConfirmErrorNotificationProps = {
  title: string
  copy: Readonly<string | string[]>
  planInfo: ChangePlanUIInfo
}

export default function ChangePlanConfirmErrorNotification({
  title,
  copy,
  planInfo,
}: Readonly<ChangePlanConfirmErrorNotificationProps>) {
  return (
    <AlertWithScrollIntoView>
      <Typography as="p" data={planInfo} variant="speakUp">
        {title}
      </Typography>
      <Typography as="div" data={planInfo}>
        {copy}
      </Typography>
    </AlertWithScrollIntoView>
  )
}
